import type { ComponentType } from "react";

import { LiveArticleScrollContextProvider } from "./contexts";

export function withLiveArticleScrollContext<Props extends object>(
  Component: ComponentType<Props>,
) {
  const WrappedComponent = (props: Props) => (
    <LiveArticleScrollContextProvider>
      <Component {...props} />
    </LiveArticleScrollContextProvider>
  );
  return WrappedComponent;
}
